<ng-container [formGroup]="form">
  <div class="input-group">
    <input
      type="text"
      class="input-group-field"
      [id]="formModel.id"
      [formControlName]="formModel.id"
      [matAutocomplete]="autocompleteAddress"
      (input)="onInput($event)"
      (blur)="onBlur()"
      autocomplete="off"
    >
    <mat-autocomplete #autocompleteAddress="matAutocomplete">
      <mat-option *ngIf="getDropdownHint() as hint" [disabled]="true" class="autocomplete-hint">
        {{ (step + '.' + formModel.id + '.hint.' + hint) | translate }}
      </mat-option>
      <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.freeformAddress" (onSelectionChange)="onSuggestionSelected(suggestion)">
        {{suggestion.freeformAddress}}
      </mat-option>
    </mat-autocomplete>
  </div>
</ng-container>
